<template>
  <div class="serialNumber">
    <div class="header">
      <el-button type="primary" size="small"  @click="AddSerialNumbers()">添加</el-button>
      <el-button type="primary" size="small" @click="dialogVisible1()" style="margin-bottom: 10px;">批量删除</el-button>
<!--     添加、编辑-->
      <el-dialog :title="formStrand.dialogTitle" :visible.sync="dialogFormVisible3" width="50%" top="0px" :close-on-click-modal="false">
        <el-form ref="form" :model="formStrand" label-width="180px">
          <el-form-item label="IPv4名称" size="small"><el-input  v-model="formStrand.strandlistName"></el-input></el-form-item>
           <el-form-item label="IPv4分组">
           			<el-select v-model="formStrand.groupId" multiple  placeholder="请选择"
                      style="width: 100%;" size="small"
                      @change="groupChange">
           				<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
           			</el-select>
           		</el-form-item>
           		<el-form-item v-for="(item, index) in selectData" :key="index" :label="item.gName" size="small">
           <el-input  v-model="item.gkey"></el-input>
           </el-form-item>

          <el-form-item label="IPv4列表" size="small">
            <el-input type="textarea" :rows="13" v-model="formStrand.sn"></el-input>
            <el-tag type="danger">多个IP格式(英文逗号分隔)：192.168.1.1,192.168.1.2</el-tag>
            <el-tag type="danger">号段格式(英文横杠，逗号分隔)：192.168.1.1-192.168.1.255</el-tag>
            <el-tag type="danger">既有号段又有单个号(英文横杠，逗号分隔):192.168.1.1-192.168.1.255,192.168.0.1</el-tag>
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible3 = false" size="small">取 消</el-button>
          <el-button type="primary" @click="Save_serialNumbers()" size="small">确 定</el-button>
        </div>
      </el-dialog>
<!--      确认删除-->
      <el-dialog
        :visible.sync="dialogVisible"
        width="30%"
      >
        <span v-if = 'formStrand.ids == 0'>请选择数据</span>
        <p style="margin: 0px;height: 40px; line-height: 44px;" v-if = "formStrand.ids != 0">
          <i class="el-icon-delete-solid" style="font-size: 40px; color:#409EFF;float: left;"></i>
          <span style="float: left;">确定删除吗？</span>
        </p>
        <span slot="footer" class="dialog-footer">
			    <el-button @click="dialogVisible = false"  size="small">取 消</el-button>
			    <el-button type="primary" @click="delcategory()"  size="small">确 定</el-button>
			  </span>
      </el-dialog>
      <!-- 分页 -->
      <el-pagination
        class="paging"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="formStrand.pageNo"
        :page-size="formStrand.pageSize"
        layout="total, prev, pager, next"
        :pager-count="7"
        :total="formStrand.totalCount">
      </el-pagination>
    </div>
    <div :style="{height:tableHeight - 90 +'px'}">
      <el-table
        :maxHeight="tableHeight - 90 + 'px'"
        size="small"
        ref="multipleTable"
        :data='formStrand.strandlist'
        tooltip-effect="dark"
        border
        @selection-change="handleSelectionChange = arguments[0]"
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column label="IP名称" >
          <template slot-scope="scope">
            {{ scope.row.cname }}
          </template>
        </el-table-column>
        <el-table-column prop="sns" label="IP列表">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.sns }}</p>
              <div slot="reference" class="name-wrapper" v-if="scope.row.sns">
                <el-tag size="medium">{{ scope.row.sns }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column  label="IP分组" width="200">
          <template slot-scope="scope">
            {{ scope.row.gname }}
          </template>
        </el-table-column>

        <el-table-column label="操作" width="120" show-overflow-tooltip align="center">
          <template scope="scope">
            <el-button type="primary" size="small"    @click="AddSerialNumbers(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import api from '@/api/menu/'
  import { mapState } from 'vuex';
  export default {
    props: {
      terminalId: {
        type: String
      },
    },
    computed: {
      ...mapState('main', ['tableHeight'])
    },
    data() {
      return {
        dialogVisible: false,
		    selectData: [],
        dialogTitle:'',//添加和编辑
        dialogFormVisible3: false,
        formStrand:{ //IP分组
          'pageNo':1,
          'pageSize':15,
          totalCount: 0,//总条数
          type:2,//1:串号 2:IP 3:nube
          strandlist:[],
          strandlistName:'',
          dialogTitle:"",
          id:'',
          sn:'',
          groupId:'',
          name:'',
          token:'',
          list:[],
          ids:[],
          groupKey: '',
        },
        options1:[],
        options: [],
        handleSelectionChange:[],//获取删除的id和token
        formLabelWidth: '120px'
      };
    },
    created() {
      // this.formStrand.token = this.$cookies.get('USER_TOKEN_COOKIE');
      this.querycategory();
      this.querygroup();
    },
    methods: {
      dialogVisible1(){
        this.dialogVisible = true;
        this.formStrand.ids = this.handleSelectionChange.map(item => item.id);
      },
      // 删除
      delcategory(){
        this.dialogVisible = false;
        var ids = [];
        if(this.formStrand.ids.length == 0){
          ids = this.formStrand.ids;
        }else{
          ids = this.formStrand.ids;

          var data = {
            'ids':this.formStrand.ids,
            'token':this.formStrand.token
          };
          api.delcategory(data)
            .then(res => {
              if(res.data.code == 0){

                if(this.formStrand.ids.length == 0){
                }else{
                  this.querycategory();
                  successMsg({
                    message: '删除成功'
                  })
                }
              }else{
                errorMsg({
                  message: res.data.msg
                })
              }
            })
        }
      },
      //改变每页显示数量时调用
      handleSizeChange(val) {
        this.$nextTick(() =>
          this.querycategory(),
        )
      },
      //点击下一页和点击页码时执行
      handleCurrentChange(val) {
        this.querycategory();
      },
      // 11.9 查询分组
      querygroup(){
        var data = {
          'terminalId':this.terminalId,
          'pageNo':1,
          'pageSize':10000,
          // 'token':this.$cookies.get('USER_TOKEN_COOKIE'),
        };
        api.querygroup(data)
          .then(res => {
            if(res.data.code == 0){
              this.options = res.data.data.list;
            }else{
              errorMsg({
                message: res.data.msg
              })
            }
          })
      },

      // 11.24获取IP信息
      queryserialno(){
        var data = {
          'sn':'',
          'token':this.formStrand.token,
          'pageNo':this.formStrand.pageNo,
          'pageSize':this.formStrand.pageSize,
        };
        api.queryserialno(data)
          .then(res => {
            if(res.data.code == 0){
              this.options1 = res.data.data.list;
              console.log(res);
            }else{
              console.log(res.data.msg);
              errorMsg({
                message: res.data.msg
              })
            }
          })
      },
      // 时间格式
      formatCreateDate: function(row) {
        let createDate = row;
        return window.formatDate(createDate);
      },
      // 添加IP
      AddSerialNumbers(parameter){
        if(parameter){
          this.queryserialno()

          this.formStrand.dialogTitle = "编辑IPv4分组";
          this.dialogFormVisible3 = true;
          this.formStrand.strandlistName = parameter.cname;
          // this.formStrand.groupId = parameter.groupId;
		  this.formStrand.groupId = parameter.gIds.split(",");
          this.formStrand.groupKey = parameter.groupKey;
          this.formStrand.id = parameter.id;
		  this.setSelectData(parameter);
          // this.formStrand.groupId = parameter.gname;
          var src = parameter.sns;
          var src1 = src.split(',')
          if(parameter.sns){
            this.formStrand.sn = src1.toString();
          }else{
            this.formStrand.sn = '';
          }
        }else{
          this.queryserialno()
          //this.querygroup();//获取分组的
          this.formStrand.dialogTitle = "添加IPv4分组"
          this.dialogFormVisible3 = true;
          this.formStrand.strandlistName = '';
          this.formStrand.name = '';
          this.formStrand.id = '';
          this.formStrand.sn = '';
          this.formStrand.groupId = '';
          this.formStrand.groupKey = '';
		  this.selectData = "";
        }
      },
      // 添加编辑 保存 IP
      Save_serialNumbers(){

	  var _this = this;
	  var _arrayKey = [];
	  _this.selectData.forEach(obj =>{

	  		  for(var j=0;j<_this.formStrand.groupId.length;j++){
	  			  if(_this.formStrand.groupId[j] == obj.gid){
	  				 _arrayKey.push( obj.gkey);
	  			  }
	  		  }

	  })

	  if(_arrayKey.length != _this.formStrand.groupId.length){
	  		  errorMsg({
	        message: '选择分组的个数与分组对外的key个数不匹配'
	      });
	  		  return;
	  }



        var sn = this.formStrand.sn.toString()
        var data = {
          'sn':sn,
          'token':this.formStrand.token,
          'groupId':this.formStrand.groupId.join(),
          'type':this.formStrand.type,
          'id':this.formStrand.id,
          'name':this.formStrand.strandlistName,
          'groupKey': _arrayKey.join(),
        };
        api.editcategory(data)
          .then(res => {
            if(res.data.code == 0){
              this.querycategory();
              successMsg({
                message: '保存成功'
              })
              this.dialogFormVisible3 = false;
              console.log(res);
            }else{
              errorMsg({
                message: res.data.msg
              })
              this.dialogFormVisible3 = true;
            }
          })
      },
      // IP分组初始化
      querycategory(){
        this.formStrand.strandlist = [];
        var data = {
          'name':"",
          'sn':'',
          'terminalId':this.terminalId,
          'type':this.formStrand.type,
          'token':this.formStrand.token,
          'pageNo':this.formStrand.pageNo,
          'pageSize':this.formStrand.pageSize,
          // 'groupType':'1'
        };
        api.querycategory(data)
          .then(res => {
            if(res.data.code == 0){
              this.formStrand.strandlist = res.data.data.list;
              this.formStrand.totalCount = res.data.data.totalSize
              console.log(res);
            }else{
              console.log(res.data.msg);
              errorMsg({
                message: res.data.msg
              })
            }
          })
      },
    groupChange() {
      console.log(this.formStrand.groupId);
      //   this.options.forEach(obj=>{
      //     if(obj.id == this.formStrand.groupId){
      //       this.formStrand.groupKey = obj.npsKey;
      //     }
	  //   })
	  var _this = this;
      var arraySelectData = [];
      for (var i = 0; i < _this.formStrand.groupId.length; i++) {
        var gid = _this.formStrand.groupId[i];
        //if (this.selectData.indexOf(gid) == -1) {
          _this.options.forEach(obj => {
            if (obj.id == gid) {
              arraySelectData.push({
                gid: gid,
                gkey: obj.npsKey,
                gName: obj.name
              });
            }
          });
        //}
	  }
	  var arrayData = [];
	  arraySelectData.forEach(obj =>{
		  let isExist = false;
		  let _obj =null;
		  for(var j=0;j<_this.selectData.length;j++){
			  if(_this.selectData[j].gid == obj.gid){
				  isExist = true;
				  _obj = _this.selectData[j];
			  }
		  }
		if(isExist){
			arrayData.push(_obj);
		}else{
			arrayData.push(obj);
		}
	  })
	  this.selectData = arrayData;
    },
	setSelectData(parameter){
		console.log(parameter)
		var arrayData = [];
		var arrayKey = parameter.groupKey.split(",");
		var arrayGids = parameter.gIds.split(",");
		for (var i = 0; i < arrayGids.length; i++) {
	    var gid = arrayGids[i];
	    //if (this.selectData.indexOf(gid) == -1) {
	      this.options.forEach(obj => {
	        if (obj.id == gid) {
	          arrayData.push({
	            gid: gid,
	            gkey: arrayKey[i],
	            gName: obj.name
	          });
	        }
	      });
	    //}
	  }
	this.selectData = arrayData;
	},
    }
  };
</script>
<style scoped lang="less">
  .serialNumber {
    .crumbs {
      margin-top: 10px;
    }
    .header {
      position: relative;
      // height: 60px;
      // line-height: 60px;
      .paging{
        position: absolute;
        right: 0px;
        top: 0px;
      }
      .search {
        width: 200px;
      }
    }
    .a {
      cursor: pointer;
    }
  }
</style>
